import { combineReducers } from 'redux';
import { carClaimDetailsReducer } from './CarClaimDetails';
import { personalAccidentClaimDetailsReducer } from './PersonalAccidentClaimDetails';
import { cancerClaimDetailsReducer } from './CancerClaimDetails';
import { healthClaimDetailsReducer } from './HealthClaimDetails';
import { requestDocumentsModalReducer } from './RequestDocumentsModal';

export default combineReducers({
  carClaimDetails: carClaimDetailsReducer,
  personalAccidentClaimDetails: personalAccidentClaimDetailsReducer,
  cancerClaimDetails: cancerClaimDetailsReducer,
  healthClaimDetails: healthClaimDetailsReducer,
  requestDocumentsModalReducer: requestDocumentsModalReducer,
});
